<script lang="ts">
import domUtils from 'util/dom-utils'
import reviewSubmissionConfig from 'widgets/submission/review-submission.config'


export default {
  data() { return { containerWidth: 0 } },
  computed: {
    mediaSize() {
      if (this.isSingleItemView) {
        return this.containerWidth
      }
      for (let i = 0; i < this.mediaSizes.length; i++) {
        if (this.mediaSizes[i].containerWidth <= this.containerWidth) {
          return this.mediaSizes[i].mediaSize
        }
      }
      return 0
    },
    mediaSizes() {
      // sort from largest to smallest
      // slice(0) used to copy array before sorting
      return reviewSubmissionConfig.mediaSizes.slice(0).sort((a, b) => {
        return b.containerWidth - a.containerWidth
      })
    }
  },
  mounted() {
    // using parent because add-media component is inside the parent container
    // TODO: may need to add resize listener to handle changing widths. Leaving for now
    // until it becomes a problem
    domUtils.whenElementIsVisible(this.$parent.$el).then(() => {
      this.containerWidth = this.$parent.$el.clientWidth
    }).catch(() => {})
  }
}
</script>
